import { createContext, useContext } from 'react';
import type { RefObject } from 'react';
import type { HubConnection } from '@microsoft/signalr';
import type { SignalRConnectionStatus } from '@/core/realtime/public';

export interface NotificationHubContextValue {
  /** Ref to the active SignalR HubConnection. null when disconnected or hub URL not configured. */
  connectionRef: RefObject<HubConnection | null>;
  status: SignalRConnectionStatus;
  reconnectCount: number;
}

export const NotificationHubContext = createContext<NotificationHubContextValue | null>(null);

/**
 * Returns the shared SignalR connection established by NotificationsProvider.
 * Must be called inside the NotificationsProvider tree.
 */
export function useNotificationHubContext(): NotificationHubContextValue {
  const ctx = useContext(NotificationHubContext);
  if (!ctx) {
    throw new Error('useNotificationHubContext must be used inside NotificationsProvider');
  }
  return ctx;
}
